import React from 'react';
import { ITabPanel } from './interfaces';
import { Box } from '@mui/material';

export const TabPanel: React.FC<ITabPanel> = ({
  value,
  index,
  children,
}): JSX.Element => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{
        display: value === index ? 'block' : 'none',
        height: '100%',
      }}
    >
      {children}
    </Box>
  );
};
